const TableCellEnum = ({ enumDict, value }) => {
  return <div className="table-cell-enum">{enumDict[value]}</div>;
};

export default TableCellEnum;
